
import { UserRound, X } from "lucide-react";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Button } from "@/components/ui/button";

interface AvatarDisplayProps {
  avatarUrl: string | null;
  firstName: string;
  lastName: string;
  isUploading: boolean;
  onRemoveAvatar: () => void;
}

export const AvatarDisplay = ({
  avatarUrl,
  firstName,
  lastName,
  isUploading,
  onRemoveAvatar
}: AvatarDisplayProps) => {
  return (
    <div className="relative">
      <Avatar className="h-28 w-28 overflow-hidden">
        {avatarUrl ? (
          <AvatarImage 
            src={avatarUrl} 
            alt={`${firstName} ${lastName}`} 
          />
        ) : null}
        <AvatarFallback className="text-xl">
          <UserRound className="h-12 w-12" />
        </AvatarFallback>
      </Avatar>
      
      {avatarUrl && (
        <Button
          variant="destructive"
          size="icon"
          className="absolute -top-2 -right-2 h-8 w-8"
          onClick={onRemoveAvatar}
          disabled={isUploading}
        >
          <X className="h-4 w-4" />
        </Button>
      )}
    </div>
  );
};
